import { defineMessages } from 'react-intl';

const messages = defineMessages({
    expandButtonLabel: {
        defaultMessage: 'Expand',
        description: 'Aria label for toggle button that expands/collapses sidebar (collapsed state)',
        id: 'boxui.collapsiblesidebar.expandBtnLabel',
    },
    collapseButtonLabel: {
        defaultMessage: 'Collapse',
        description: 'Aria label for toggle button that expands/collapses sidebar (expanded state)',
        id: 'boxui.collapsiblesidebar.collapseBtnLabel',
    },
});

export default messages;
